/** @jsx jsx */
import Icon from '@zapier/common-components/src/components/Icon';
import { jsx, Interpolation } from '@emotion/core';

const getIconCss = (isOpen: boolean): Interpolation => ({
  display: 'inline-flex',
  transition: 'transform 200ms ease-in-out',
  transform: isOpen ? 'rotate(-180deg)' : undefined,
});

export default function AccordionArrow(props: { isOpen: boolean }) {
  return (
    <div css={getIconCss(props.isOpen)}>
      <Icon name="arrow-down" />
    </div>
  );
}
